<div class="mdc-notched-outline__leading"></div>
<div class="mdc-notched-outline__notch" #notch>
  <ng-content></ng-content>
</div>
<div class="mdc-notched-outline__trailing"></div>
